import { isNil } from "lodash-es";
import { booleanType, ensure, numberType, stringType, TType } from "types";

import { configDatabaseRecordType, configSystemRecordType, IDatabaseRecord, IId, ISystemRecord } from "@/core/api";

export interface IAttachment
  extends Partial<Pick<IDatabaseRecord, "createdBy" | "createdDate" | "modifiedBy" | "modifiedDate">>,
    IId,
    ISystemRecord {
  name: string;
  contentType: string;
  publicUrl: string | null;
  parsed?: boolean;
  parentId?: number | null;
  defaultFile?: boolean | null;
}

export enum TAttachmentPurpose {
  LOGO = "LOGO",
  CV = "CV",
  AVATAR = "AVATAR",
  ATTACHMENT = "ATTACHMENT",
}

export const configAttachmentType: TType<IAttachment> = {
  ...configDatabaseRecordType,
  ...configSystemRecordType,
  name: stringType(""),
  contentType: stringType(""),
  publicUrl: v => (isNil(v) ? null : stringType(null)(v)),
  parsed: booleanType(false),
  parentId: numberType(null),
  defaultFile: booleanType(false),
};

export const attachmentType = ensure(configAttachmentType);
